import { render, staticRenderFns } from "./TrademarkProvisionalList.vue?vue&type=template&id=00d78142&"
import script from "./TrademarkProvisionalList.vue?vue&type=script&lang=js&"
export * from "./TrademarkProvisionalList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkProvisionalList.vue?vue&type=style&index=0&id=00d78142&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports